import { Avatar } from '@/components/Avatar';
import { LinkableCard } from '@/components/Custom/Card/LinkableCard';
import { InfoWithIcon } from '@/modules/Home/components/InfoWithIcon';
import { EnvelopeIcon } from '@/components/SvgIcons/EnvelopeIcon';
import { PhoneIconV2 } from '@/components/SvgIcons/PhoneIconV2';
import { twMerge } from 'tailwind-merge';

interface RegisteredUserCardProps {
  linkTo?: string;
  avatarUrl?: string;
  fullName: string;
  companyName: string | React.ReactNode;
  registrationDate: string;
  email: string;
  phone: string;
  containerClassName?: string;
}

export const RegisteredUserCard = ({
  linkTo,
  avatarUrl,
  fullName,
  companyName,
  registrationDate,
  email,
  phone,
  containerClassName,
}: RegisteredUserCardProps) => {
  return (
    <LinkableCard
      linkTo={linkTo}
      containerClassName={twMerge('min-h-[99px]', containerClassName)}
    >
      <div className="h-full flex flex-1 flex-wrap items-center gap-3.5 max-sm:gap-2">
        <div className="flex justify-center items-center gap-3.5 max-sm:w-full max-sm:justify-start max-sm:gap-3">
          <Avatar
            imageUrl={avatarUrl}
            containerClassName="w-[55px] h-[55px] rounded-full border-0 shadow-0 max-sm:w-[45px] max-sm:h-[45px]"
          />
          <div className="hidden max-sm:block">
            <div className="text-sm text-gray-5D5D5D font-medium">
              {fullName}
            </div>
            <div className="text-xs text-gray-5D5D5D">{companyName}</div>
          </div>
        </div>
        <div className="flex flex-1 flex-col">
          <div className="max-sm:hidden">
            <div className="text-sm text-gray-5D5D5D font-medium">
              {fullName}
            </div>
            <div className="text-xs text-gray-5D5D5D">{companyName}</div>
          </div>
          <div className="mt-1.75 flex flex-wrap justify-between items-center gap-3.5 max-[1450px]:mt-1.75 max-[1450px]:gap-3.5 max-md:mt-2 max-md:gap-0.5">
            <InfoWithIcon
              containerClassName="max-[1450px]:w-auto max-md:w-full"
              icon={
                <i className="-mt-0.5 ki-outline ki-calendar text-[17px]" />
              }
              text={registrationDate}
            />
            <InfoWithIcon
              containerClassName="max-[1450px]:w-auto max-md:w-full"
              icon={
                <EnvelopeIcon className="mr-0.5 h-4 w-4 [&>path]:fill-gray-272727" />
              }
              text={email}
            />
            <InfoWithIcon
              containerClassName="max-[1450px]:w-auto max-md:w-full"
              icon={
                <PhoneIconV2 className="mt-0.5 h-4 w-4 [&>path]:fill-gray-272727" />
              }
              text={phone}
            />
          </div>
        </div>
      </div>
    </LinkableCard>
  );
};
